<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            title="UPDATE PRODUCT ORDER & ADDRESS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card-custom no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateProductOrder)" autocomplete="off">

         <span>
           <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <vx-card-custom title="Change Address">
                  <ValidationProvider vid="formulation_items" name="formulation_items" rules="" v-slot="{ errors }">
                <small class="label">Select a delivery address to change</small>
                <v-select
                  v-on:input="onChangeSelectDeliveryAddress"
                  name="formulation_items" placeholder=""
                  :reduce="option => option"
                  label="country"
                  :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                      <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      <span style="font-weight: normal">{{ option.name }}</span> <span v-if="option.name">, </span>
                      <span style="font-weight: normal">{{ option.line1 }}</span> <span v-if="option.line1">, </span>
                      <span style="font-weight: normal">{{ option.line2 }}</span> <span v-if="option.line2">, </span>
                      <span style="font-weight: normal">{{ option.line3 }}</span> <span v-if="option.line3">, </span>
                      <span style="font-weight: normal">{{ option.town_state }}</span> <span v-if="option.town_state">, </span>
                      <span style="font-weight: normal">{{ option.post_code }}</span> <span v-if="option.post_code">, </span>
                      <span style="font-weight: normal">{{ option.country }}</span> <span v-if="option.country">, </span>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>
                </vx-card-custom>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <vx-card-custom title="Current Address">
                  <div class="vx-row mb-3">
                <div class="vx-col md:w-full w-full md:mb-0">
                  <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                    <small class="label">Name</small>
                    <vs-input readonly v-model="createForm.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                  </ValidationProvider>
                </div>
             </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input readonly v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input readonly v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input readonly v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input readonly v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input readonly v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select disabled :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="createForm.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full">
                      <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                        <small class="label">Delivery Instructions</small>
                        <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="150px" />
                        <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </vx-card-custom>
              </div>
           </div>
         </span>

          <vx-card-custom title="Change Order Details">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="customers_order_number" name="customers_order_number" rules="" v-slot="{ errors }">
                  <small class="label">Customer PO Number</small>
                  <vs-input v-model="createForm.customers_order_number"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="sage_department" name="sage_department" rules="" v-slot="{errors}">
                  <small class="label">Sage Department</small>
                  <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                            label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                            :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="region" name="region" rules="" v-slot="{errors}">
                  <small class="label">Region</small>
                  <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                            label="name" v-model="createForm.region_id" :reduce="option => option.id"
                            :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <!-- <div class="vx-col md:w-1/3 w-full md:mb-0">
                <ValidationProvider vid="required_by" name="required_by" rules="" v-slot="{ errors }">
                  <small class="label">Required By Date</small>
                  <flat-pickr style="display: none" class="w-full" :config="{ dateFormat: 'd/m/Y'}"
                              v-model="createForm.required_by" placeholder="Choose Date"
                  />
                  <flat-pickr
                    class="w-full"
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="createForm.required_by"
                    placeholder="Choose Date"
                  />
                </ValidationProvider>
              </div> -->
              <div class="vx-col md:w-2/3 w-full md:mb-0">
                      <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                        <small class="label">Notes (private)</small>
                        <vs-textarea class="mb-0" v-model="createForm.note" height="100px" />
                        <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                      </ValidationProvider>
              </div>
            </div>
          </vx-card-custom>

<!--          <vs-table id="create-product-order-table" :data="createForm.formulation_items" stripe>-->
<!--            <template slot="header">-->
<!--&lt;!&ndash;              <h3>&ndash;&gt;-->
<!--&lt;!&ndash;                <span class="text-danger text-lg mb-8">Available credit (GBP):  <b>{{creditDetails.available_credit}}</b></span>&ndash;&gt;-->
<!--&lt;!&ndash;              </h3>&ndash;&gt;-->
<!--            </template>-->
<!--            <template slot="thead">-->
<!--              <vs-th width="15%">CODE</vs-th>-->
<!--              <vs-th width="20%">NAME</vs-th>-->
<!--              <vs-th width="10%">INCOTERM</vs-th>-->
<!--              <vs-th width="15%">QUANTITY (KG)</vs-th>-->
<!--              <vs-th width="10%">UNIT PRICE (KG/{{ account_currency }})</vs-th>-->
<!--              <vs-th width="15%">TOTAL PRICE ({{account_currency}})</vs-th>-->
<!--              <vs-th width="15%">ACTIONS</vs-th>-->
<!--            </template>-->

<!--            <template slot-scope="{data}">-->
<!--              <vs-tr :key="indextr" v-for="(tr, indextr) in data">-->

<!--                <vs-td :data="data[indextr].formulation_code">-->
<!--                  {{ data[indextr].formulation_code }}-->
<!--                </vs-td>-->

<!--                <vs-td :data="data[indextr].formulation_name">-->
<!--                  {{ data[indextr].formulation_name }}-->
<!--                </vs-td>-->

<!--                <vs-td :data="data[indextr].incoterm">-->
<!--                  {{ data[indextr].incoterm }}-->
<!--                </vs-td>-->

<!--                <vs-td :data="data[indextr].quantity">-->
<!--                  {{ data[indextr].quantity }}-->
<!--                </vs-td>-->
<!--                <vs-td :data="data[indextr].unit_price">-->
<!--                  {{ data[indextr].unit_price }}-->
<!--                </vs-td>-->

<!--                <vs-td :data="data[indextr].unit_price">-->
<!--                  {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}-->
<!--                </vs-td>-->

<!--                <vs-td>-->

<!--                </vs-td>-->

<!--              </vs-tr>-->

<!--            </template>-->

<!--          </vs-table>-->

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card-custom>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  import vSelect from 'vue-select'
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      customerId: '',
      sage_nominal_codes:[],
      sage_departments:[],
      regions:[],
      createForm: {
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction:'',
        note: '',
      },
      countryCodes: [],
      addresses: [],
      onClickAddressChange: false
    }
  }

  export default {
    name: 'UpdateCustomerProductOrderPopUp',
    data () {
      return initialState()
    },
    props: {
      account_currency: {
        default: 'GBP'
      }
    },
    methods:{
      async openPopup (id, customerId) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.customerId = customerId
          await this.getCountryCodes()
          await this.getAddresses()
          await this.getProductOrdersOrder()
          await this.getSageNominalCodes()
          await this.getSageDepartments()
          await this.getRegions()
          this.open = true;
        } catch (error) {

        }
      },
      async onClickUpdateProductOrder () {
        const vue = this;
        this.$vs.loading()
        try {
          await CustomerRepository.updateCustomerProductOrder(this.id, this.createForm)
          this.showSuccessMessage('Product order update successfully')
          await vue.$parent.refreshData()
          this.open = false;
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getProductOrdersOrder() {
        this.$vs.loading()
        try {
          const {data} = await CustomerRepository.getCustomerProductOrder(this.id)
          this.createForm.name =  data.data.name
          this.createForm.line1 =  data.data.line1
          this.createForm.line2 =  data.data.line2
          this.createForm.line3 =  data.data.line3
          this.createForm.town_state =  data.data.town_state
          this.createForm.post_code =  data.data.post_code
          this.createForm.country =  data.data.country
          this.createForm.delivery_instruction =  data.data.delivery_instruction
          this.createForm.note = data.data.note
          this.createForm.customers_order_number =  data.data.customers_order_number
          this.createForm.sage_department_id = data.data.sage_department.id ? data.data.sage_department.id : null
          this.createForm.region_id = data.data.region.id ? data.data.region.id : null
          this.createForm.add_costs = data.data.add_costs.map((x) => {
            return {
              name: x.name,
              amount: Number(x.amount).toFixed(2),
              vat_percent: Number(x.vat_percent).toFixed(2),
              sage_nominal_code_id: x.sage_nominal_code_id,
              is_removed:false,
            }
          })
          // this.createForm.required_by = data.data.required_by ? data.data.required_by : null
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getCountryCodes() {
        this.$vs.loading()
        this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        this.$vs.loading.close()
      },
      async getAddresses() {
        this.$vs.loading()
        this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.customerId)).data.data;
        this.$vs.loading.close()
      },
      async getSageNominalCodes(){
        this.$vs.loading()
        const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
        this.sage_nominal_codes =  data.data
        this.$vs.loading.close()
      },
      async getSageDepartments(){
        this.$vs.loading()
        const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
        this.sage_departments =  data.data
        this.$vs.loading.close()
      },
      async getRegions(){
        this.$vs.loading()
        const {data} = await RegionsRepository.getListOfRegions()
        this.regions =  data.data
        this.$vs.loading.close()
      },
      onChangeSelectDeliveryAddress(selected) {
        this.createForm.name = selected.name
        this.createForm.line1 = selected.line1
        this.createForm.line2 = selected.line2
        this.createForm.line3 = selected.line3
        this.createForm.town_state = selected.town_state
        this.createForm.post_code = selected.post_code
        this.createForm.country = selected.country

        this.createForm.delivery_instruction = selected.additional_info
        this.onClickAddressChange = false
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
    },
    components: {
      'v-select': vSelect,
      flatPickr,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
